import { module } from 'modujs';
import {html } from '../utils/environment';
import modularLoad from 'modularload';

export default class extends module {
    init() {
        this.analyticsId = this.getData('analytics');

        this.load = new modularLoad({
            enterDelay: 1000,
            transitions: {
                customTransition: {}
            }
        });

        this.load.on('loading',(transition, oldContainer) => {
            html.classList.remove('has-dom-ready');
            html.classList.remove('is-animated');

            setTimeout(() => {
                html.classList.remove('has-nav-open');
            },600)

        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if(window.gtag && this.analyticsId != null) {
                gtag('config', this.analyticsId, {
                    'page_path':  location.pathname,
                    'page_title': document.title
                });
            }

            setTimeout(() => {
                html.classList.add('has-dom-ready');

                setTimeout(() => {
                    html.classList.add('is-animated');
                    this.call('updatePositions','Transition');
                }, 1200);
            }, 1000);
        });
    }

    goTo(options) {
        this.load.goTo(options.url, options.transitionName);
    }
}
